import { render, staticRenderFns } from "./PopUpGeneratedReports.vue?vue&type=template&id=a4d77f94&"
import script from "./PopUpGeneratedReports.vue?vue&type=script&lang=ts&"
export * from "./PopUpGeneratedReports.vue?vue&type=script&lang=ts&"
import style0 from "./PopUpGeneratedReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a4d77f94', component.options)
    } else {
      api.reload('a4d77f94', component.options)
    }
    module.hot.accept("./PopUpGeneratedReports.vue?vue&type=template&id=a4d77f94&", function () {
      api.rerender('a4d77f94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SIMSolicitudes/PopUpGeneratedReports.vue"
export default component.exports